import "../../styles/visualization/visualizationHeader.css";

const VisualizationHeader = ({ title, description, tags }) => {
  return (
    <section className="visulaization-header">
      <div className="visulaization-header-inner">
        <h1 className="visulaization-title">{title}</h1>

        {description && (
          <p className="visulaization-description">{description}</p>
        )}

        {tags?.length > 0 && (
          <div className="visulaization-tags">
            {tags.map((tag, index) => (
              <span className="visulaization-tag" key={index}>
                #{tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default VisualizationHeader;
